import { AppState, useAppSelector } from '@redux/store';
import { RequestToSpeakStatus } from '@typings/requestToSpeak';

export const useRequestToSpeakById = (id: string) =>
  useAppSelector(({ requestsToSpeak }: AppState) => requestsToSpeak.byId[id]);

export const useParticipantRequestToSpeak = (showId: string) =>
  useAppSelector(({ requestsToSpeak }: AppState) => {
    const values = Object.values(requestsToSpeak.byId);

    return values.find(
      (request) =>
        request.showId === showId &&
        (request.status === RequestToSpeakStatus.Pending ||
          request.status === RequestToSpeakStatus.WaitingForPayment),
    );
  });
